import React, { useCallback, useState } from 'react';

type IframeContainerProps = {
    src: string;
    title: string;
    height?: string | number;
    allow?: string;
    sandbox?: string;
};

const IframeContainer: React.FC<IframeContainerProps> = ({
    src,
    title,
    height = '100%',
    allow = 'fullscreen',
    sandbox = 'allow-scripts allow-forms allow-popups',
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const handleLoad = useCallback(() => {
        setIsLoading(false);
    }, []);

    const handleError = useCallback(() => {
        setIsLoading(false);
        setHasError(true);
    }, []);

    if (hasError) {
        return (
            <div style={{ padding: 16, textAlign: 'center' }}>
                <p>Unable to load the page.</p>
                <button onClick={() => window.location.reload()}>Retry</button>
            </div>
        );
    }

    return (
        <div style={{ position: 'relative', height }}>
            {isLoading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#fff',
                        zIndex: 1,
                    }}
                >
                    <span>Loading...</span>
                </div>
            )}

            <iframe
                src={src}
                title={title}
                loading="lazy"
                onLoad={handleLoad}
                onError={handleError}
                referrerPolicy="no-referrer"
                sandbox={sandbox}
                //allow={allow}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
            />
        </div>
    );
};

export default React.memo(IframeContainer);
